<template lang="pug">
  .contenedor-interno
    .title
      span Solicitudes de permiso {{ perfilVacaciones === 'jefe' ? 'de mi equipo' : '' }}
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)

          .filtros(v-if="mostrarFiltros", key="filtros")
            .filtro
              .title-singular
                p Estado
              .select.display-flex
                select.flex-1(v-model='filtroEstado')
                  option(value="all") Todos
                  option(:value="+key", v-for="(value, key) in estados") {{ value.descripcion }}

            .filtro
              .title-singular
                p Tipo
              .select.display-flex
                select.flex-1(v-model='filtroTipo')
                  option(value="all") Todos
                  option(:value="o.codigo", v-for="(o, key) in tipos") {{ o.descripcion }}

            .filtro
              .codigo-empleado
                .control.title-singular
                  p Codigo de empleado
                  .input-container
                    input.input(
                      type="number",
                      v-model="filtroCodigoEmpleado"
                      @focus="mostrarBusquedaEmpleado = true"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                    .erase-data(@click="filtroCodigoEmpleado = ''")
                      .icon
                        .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaEmpleado"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarEmpleado"
                        @close="mostrarBusquedaEmpleado = false"
                        :codigo="filtroCodigoEmpleado"
                      )

          .boton-container(key="boton-container")
            button.button(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
      div(
        key="body-scroll"
        v-infinite-scroll="fetchByScroll"
        infinite-scroll-disabled="disabledScrollExecute"
        infinite-scroll-distance="2"
      )
        .body(key="body")
          .information
            .is-desktop(key="is-desktop")
              table.table.is-striped.is-bordered(
                v-if="lista.length !== 0"
              )
                thead
                  th Empleado
                  th Tipo
                  th Motivo
                  th Estado
                  th Adjunto
                tbody(
                  name="table-row"
                  is="transition-group"
                )
                  tr.row-table(
                    v-for="(o,index) in lista"
                    :key="o+index+''"
                    :class="{ 'is-close': !o.abierto }"
                  )
                    td.text-center
                      .hint--bottom(:aria-label="'Solicitud: ' + o.id")
                        span.hint--top(:aria-label="'Empleado: ' + o.codigoEmpleado") {{ o.nombreEmpleado }}

                    td {{ o.descripcionTipo }}
                    td
                      template(v-if="o.motivo")
                        span {{ o.motivo }}
                      template(v-else)
                        span Sin motivo
                      br
                      .dias-pedidos
                        strong Dias pedidos
                        div(v-for="i in o.detalle")
                          span.detalle-dias {{ i.desde === i.hasta ? i.desde : `${i.desde} - ${i.hasta}` }}   {{ i.horaDesde }}-{{ i.horaHasta }}
                    td {{ o.estadoData.descripcion }}
                    td.text-center
                      template(v-if="o.adjunto")
                        a.button.is-small(:href="o.adjunto", target="_blank")
                          span.icon.is-small
                            i.fa.fa-paperclip.is-small.fs-12
                          span Ver adjunto
                      template(v-else)
                        span Sin adjunto
            .is-mobile(key="is-mobile")
              .box(
                v-for="(o, index) in lista"
                :key="o+index+''"
              )
                .status
                  span {{ o.estadoData.descripcion }}
                .descripcion-tipo.hint--top(:aria-label="'Empleado: ' + o.codigoEmpleado")
                  span.is-bold.hint--bottom(:aria-label="'Solicitud: ' + o.id")
                    | {{ o.nombreEmpleado }}
                .descripcion-tipo
                  span {{ o.descripcionTipo }}
                .motivo
                  div
                    span {{ o.motivo }}
                .dias-pedidos
                  strong Dias pedidos
                  div(v-for="i in o.detalle")
                    span.detalle-dias {{ i.desde === i.hasta ? i.desde : `${i.desde} - ${i.hasta}` }}   {{ i.horaDesde }}-{{ i.horaHasta }}
                .botones
                  template(v-if="o.adjunto")
                    a.button.is-small(:href="o.adjunto", target="_blank")
                      span.icon.is-small
                            i.fa.fa-paperclip.is-small.fs-12
                      span Ver adjunto
          .is-loading(v-if="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
          .message.is-warning(v-if="lista.length === 0 && !isLoading")
            .message-body
              span.has-text-bold No existe información con los filtros definidos
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiGet, notify } from '../util/general'
export default {
  name: 'reporte_permisos_solicitud_component',
  data () {
    return {
      lista                       : [],
      isLoading                   : false,
      mostrarBusquedaEmpleado     : false,
      mostrarFiltros              : true,
      solicitudSeleccionada       : {},
      filtroCodigoEmpleado        : '',
      filtroEstado                : 3,
      filtroTipo                   : 'all',
      estados                     : [],
      tipos                       : [],
      perfilVacaciones            : localStorage.getItem('perfilVacaciones'),
      isScroll               : false,
      disabledScrollExecute : true,
      skip                   : 0,
      noMore                 : false
    }
  },
  components: {
    LookupSmallEmpleado
  },
  created () {
    this.limpiarFiltros()
    this.fetchEstados()
    this.fetchTipos()
    this.fetch()
  },
  watch : {
    filtroCodigoEmpleado (value) {
      return this.fetch()
    },
    filtroEstado (value) {
      return this.fetch()
    },
    filtroTipo (value) {
      return this.fetch()
    }
  },
  methods: {
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetchEstados () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/permisos/estado', obj, function (data) {
        vm.estados = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    fetchTipos () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/permisos/tipo', obj, function (data) {
        vm.tipos = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    fetch () {
      var vm = this
      if (vm.isLoading) return

      vm.isLoading = true
      vm.disabledScrollExecute = true
      vm.noMore = false
      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        estado         : vm.filtroEstado,
        tipo            : vm.filtroTipo
      }

      var obj = {
        filtros: filtros
      }
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, '/permisos/solicitud', obj, function (data) {
        data.lista.forEach((o) => {
          vm.lista.push(o)
        })
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtroEstado = this.perfilVacaciones === 'jefe' ? 'all' : 3
      this.filtroCodigoEmpleado = ''
      this.filtroTipo           = 'all'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .is-bold
    font-weight bold
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      padding-right 3px
      padding-left 3px
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;

  .dias-pedidos
    font-size 12px
    color #9a9a9a

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px

  @media(max-width: 1205px)
    .filtros
      flex-direction: column;
      .filtro
        width 100%;

  @media(max-width: 690px)
    .is-mobile
      display block

    .is-desktop
      display none

</style>



// WEBPACK FOOTER //
// Component_Permisos_Reporte_Solicitud.vue?d246b4b8